<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 241.96 199.46"
    style="enable-background: new 0 0 241.96 199.46"
    xml:space="preserve"
    fill="currentColor"
    :class="{
      [`fill-${color} h-${height} w-${width}`]: true,
    }"
  >
    <path
      class="st0"
      d="M241.76,5.56c-0.15-0.61-0.39-1.16-0.68-1.69c-0.25-0.51-0.55-1.01-0.94-1.45c-1.74-2.02-4.43-2.82-6.94-2.21
	H6.57c-3.05,0-5.75,1.97-6.67,4.88c-0.92,2.91,0.14,6.07,2.63,7.84l92.85,65.74l-0.79,113.76c-0.02,3.05,1.93,5.76,4.83,6.7
	c0.71,0.23,1.44,0.35,2.17,0.35c2.21,0,4.35-1.05,5.69-2.92L239.51,12.49C241.46,10.81,242.39,8.15,241.76,5.56z M205.49,14.2
	L102.98,66.88L28.57,14.2H205.49z M109.37,79.34l102.6-52.51L108.74,170.5L109.37,79.34z"
    />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
    },
    height: {
      type: String,
    },
    width: {
      type: String,
    },
  },
};
</script>
